import { G_VideoSeasonType } from "~/lib/graphql";

type Args = {
  seasonId?: string;
  contentId?: string;
  search: string;
  currentUrl: URL;
  seasonType: G_VideoSeasonType;
  isOnDetail: boolean;
};

export const generateBackUrl = ({ seasonId, contentId, seasonType, isOnDetail, currentUrl, search }: Args) => {
  const queryPrefix = search.split("&").length > 1 ? "&" : "?";
  const purchaseParam = "isPurchase=true";

  // 末端で購入モーダルを開いた時のbackURL
  if (isOnDetail) return `${currentUrl}${queryPrefix}${purchaseParam}`;

  // mini末端経由&複数話の時
  if (seasonType === G_VideoSeasonType.MultiEpisodes)
    return `${currentUrl}${queryPrefix}season=${seasonId}&content=${contentId}&${purchaseParam}`;

  // その他はseasonのみ指定
  return `${currentUrl}${queryPrefix}season=${seasonId}&${purchaseParam}`;
};
